import { Link as ReactRouterLink } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import useTranslation from "../../client/hooks/useTranslation";

export interface InternalLink {
  to: string;
  label: string;
}

export default function InternalLinks({ links }: { links: InternalLink[] }) {
  const t = useTranslation();
  if (!links.length) return null;
  return (
    <section className="px-6 py-12 lg:px-8">
      <div className="mx-auto max-w-3xl">
        <h2 className="font-display text-lg font-semibold text-foreground">
          {t.marketing.common.relatedTitle}
        </h2>
        <ul className="mt-4 space-y-2">
          {links.map((l) => (
            <li key={l.to}>
              <ReactRouterLink
                to={l.to}
                className="group flex items-center gap-2 text-primary hover:underline"
              >
                <span>{l.label}</span>
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
              </ReactRouterLink>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
